import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Controller } from "react-hook-form";

interface RadioInputProps {
  fieldName: string;
  label: string;
  control: any;
  error?: boolean;
  helperText?: any;
  defaultValue?: string | null;
  options: any[];
}

const RadioInput: React.FC<RadioInputProps> = ({
  fieldName,
  control,
  label,
  error,
  helperText,
  defaultValue,
  options,
}) => {
  return (
    <FormControl component="fieldset" error={error}>
      <FormLabel component="legend">{label}</FormLabel>
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue || ""}
        render={({ field }) => (
          <RadioGroup {...field} name={fieldName} row>
            {options.map((e, i) => (
              <FormControlLabel
                key={i}
                value={e.id}
                label={e.name}
                control={<Radio size="small" />}
              />
            ))}
          </RadioGroup>
        )}
      />
      {error && (
        <FormHelperText sx={{ color: "#ef5350" }}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default RadioInput;
